export default [
  {
    type: "monthly",
    year: 2021,
    month: 1,
    hashrate: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 2,
    hashrate: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 3,
    hashrate: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 4,
    hashrate: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 5,
    hashrate: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 6,
    hashrate: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 7,
    hashrate: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 8,
    hashrate: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 9,
    hashrate: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 10,
    hashrate: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 11,
    hashrate: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 12,
    hashrate: 0,
    source: ""
  },
  /* Quarterly */
  {
    type: "quarterly",
    year: 2020,
    quarter: 1,
    hashrate: 0,
    source: ""
  },
  {
    type: "quarterly",
    year: 2020,
    quarter: 2,
    hashrate: 0,
    source: ""
  },
  {
    type: "quarterly",
    year: 2020,
    quarter: 3,
    hashrate: 0,
    source: ""
  },
  {
    type: "quarterly",
    year: 2020,
    quarter: 4,
    hashrate: 0,
    source: ""
  },
  {
    type: "quarterly",
    year: 2021,
    quarter: 1,
    hashrate: 0,
    source: ""
  },
  {
    type: "quarterly",
    year: 2021,
    quarter: 2,
    hashrate: 0,
    source: ""
  },
  {
    type: "quarterly",
    year: 2021,
    quarter: 3,
    hashrate: 0,
    source: ""
  },
  {
    type: "quarterly",
    year: 2021,
    quarter: 4,
    hashrate: 0,
    source: ""
  },
]
